module.exports = __webpack_public_path__ + "static/media/excavatorbg-bw - Copy.7aea8db4.jpg";